module.exports = __webpack_public_path__ + "fonts/Finch-Frame-2-Bold.de5fe644.eot";